import { createSlice } from '@reduxjs/toolkit'
import { chatbotEvents } from '../state'
import { portfolioApiEvents } from 'modules/api/portfolio'

export interface LeaseConfirmationState {
  requestedApproval: boolean
  isActivated: boolean
}

export const initialState: LeaseConfirmationState = {
  requestedApproval: false,
  isActivated: false,
}

const leaseConfirmationSlice = createSlice({
  name: 'chatbot/dialogs/leaseConfirmation',
  initialState,
  reducers: {
    approvalRequested: state => {
      state.requestedApproval = true
    },
  },
  extraReducers: builder => {
    builder
      .addCase(chatbotEvents.setCurrentPortfolio, (state, action) => {
        state.isActivated = action.payload?.tags?.status === 'approved'
      })
      .addCase(portfolioApiEvents.approve_success, state => {
        state.isActivated = true
      })
      .addCase(chatbotEvents.resetCurrentPortfolio, state => {
        Object.assign(state, initialState)
      })
  },
})

export const { reducer } = leaseConfirmationSlice
export const leaseConfirmationEvents = leaseConfirmationSlice.actions
